(function () {
  const initSlider = (section) => {
    const slider = section.querySelector(".nexo-testimonials-slider__swiper");
    if (!slider) return;

    if (typeof Swiper === "undefined") return;

    // Destroy existing instance (Theme Editor safe)
    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    const slidesCount = slider.querySelectorAll(".swiper-slide").length;
    const paginationEl = slider.querySelector(".swiper-pagination");

    new Swiper(slider, {
      loop: slidesCount > 3,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      watchOverflow: true,
      centeredSlides: false,
      grabCursor: true,

      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
        type: "bullets",
      },

      breakpoints: {
        750: {
          slidesPerView: 1.5,
          slidesPerGroup: 1,
          spaceBetween: 18,
          centeredSlides: true
        },
        1200: {
          slidesPerView: 3.5,
          slidesPerGroup: 1,
          spaceBetween: 22,
          centeredSlides: true
        }
      }
    });
  };

  const initSection = (sectionEl) => {
    if (sectionEl && sectionEl.classList.contains("nexo-testimonials-slider-section")) {
      initSlider(sectionEl);
    }
  };

  // First load (same pattern as your gallery script)
  const currentSection = document.currentScript.parentElement;
  initSection(currentSection);

  // Theme editor reload
  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });
})();
